import { render, staticRenderFns } from "./SaleSearch.vue?vue&type=template&id=fe0cff64"
import script from "./SaleSearch.vue?vue&type=script&lang=ts"
export * from "./SaleSearch.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports